// React & Nextjs imports
import React from "react";
import Image from "next/image";

// Hooks & Utils
// import { setAnalyticsEvent } from "@/app/utils/SetAnalyticsEvent";

// Components
import ICMWrapper from "@/app/components/icm-wrapper";

// UI Components
// import { IconButton } from "@/stories/icon-button/icon-button";
// import { ButtonSize, ButtonVariant, RegularButton } from "@/stories/button/button";

// Icons
// import Bulb from "@/app/assets/icons/bulb";
import Feat1 from "@/app/assets/images/feat-us-stock-1.png";
import Feat2 from "@/app/assets/images/feat-us-stock-2.png";
import Feat3 from "@/app/assets/images/feat-us-stock-3.png";
import Feat4 from "@/app/assets/images/feat-us-stock-4.png";
import Feat5 from "@/app/assets/images/feat-us-stock-5.png";
import Feat6 from "@/app/assets/images/feat-us-stock-6.png";
// import GlobalStocksWhyInvest from "@/app/assets/icons/global-stocks-why-invest";
// import ArrowRightWhite from "@/app/assets/icons/arrow-right-white";

interface WhyUsStocksProps {
    title: string;
    subtitle: string;
    icon: React.ReactNode;
}

export default function GlobalInvest() {
    const GlobalInvesting: WhyUsStocksProps[] = [
        {
            title: "Currency Movement",
            subtitle: "Returns can be impacted by exchange rate fluctuations",
            icon: (
                <div className="mb-7">
                    <Image src={Feat1} height={98} width={97} alt="" />
                </div>
            ),
        },
        {
            title: "Market Volatility",
            subtitle: "Global markets can experience sharp movements",
            icon: (
                <div className="mb-7">
                    <Image src={Feat2} height={98} width={97} alt="" />
                </div>
            ),
        },
        {
            title: "Taxation",
            subtitle: "International investments may have different tax implications",
            icon: (
                <div className="mb-7">
                    <Image src={Feat3} height={98} width={97} alt="" />
                </div>
            ),
        },
        {
            title: "Regulatory Limits",
            subtitle: "Investments are subject to prescribed limits under applicable regulations",
            icon: (
                <div className="mb-7">
                    <Image src={Feat4} height={98} width={97} alt="" />
                </div>
            ),
        },
        {
            title: "Investment Horizon",
            subtitle: "Global investing typically works better with a long-term approach",
            icon: (
                <div className="mb-7">
                    <Image src={Feat5} height={98} width={97} alt="" />
                </div>
            ),
        },
        {
            title: "Allocation Matters",
            subtitle: "US stocks should be part of a broader, balanced portfolio",
            icon: (
                <div className="mb-7">
                    <Image src={Feat6} height={98} width={97} alt="" />
                </div>
            ),
        },
    ];

    return (
        <div className="bg-[url('https://assets.incredmoney.com/images/webp/broking-hero-top-left.webp')] bg-[length:90%] bg-no-repeat md:bg-[length:35%]">
            {" "}
            {/* bg-[#334155] */}
            <ICMWrapper>
                <div className="flex flex-col items-center py-s15 md:py-s20 md:pb-s16">
                    <h2 className="mb-14 text-center text-4xl font-semibold -tracking-[0.56px] md:mb-20 md:text-7xl md:leading-[67.2px]">
                        Global investing requires a<br />
                        different perspective
                    </h2>
                    <div className="mb-16 flex flex-col items-center justify-between gap-11 md:flex-row md:flex-wrap">
                        {GlobalInvesting.map((item, index) => (
                            <div
                                key={index}
                                className="flex flex-col items-center justify-center align-middle md:w-1/4"
                            >
                                {item.icon}
                                <h3 className="mb-2 text-xl font-semibold leading-[26px]">
                                    {item.title}
                                </h3>
                                <p
                                    className="text-center text-sm font-regular leading-[22.4px] tracking-[0.6px]"
                                    dangerouslySetInnerHTML={{ __html: item.subtitle }}
                                ></p>
                            </div>
                        ))}
                    </div>

                    {/* <RegularButton
                        noIcon
                        showRightIcon={false}
                        size={ButtonSize.Large}
                        variant={ButtonVariant.SecondaryDefault}
                        className="w-full max-w-full border-neutralOpacityLight-30  hover:text-black md:max-w-fit"
                        label="Start Investing"
                        onClick={() => {
                            setAnalyticsEvent(
                                `${process.env.ICM_UE_URL || ""}/login`,
                                "US_Listing_Page_Start_Investing",
                            );
                            window.location.href = `${process.env.ICM_UE_URL || ""}/login`;
                        }}
                    /> */}
                </div>
            </ICMWrapper>
        </div>
    );
}
